import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import * as tracPage from '@webapp/sdk/tracpage';
import { Actions } from '../../actions';
import {
  GetTracPage,
  GetTracPageSuccess,
  GetTracPageError,
} from '../action-creators';
import { GET_TRAC_PAGE } from '../actions';
import AppState from '../../state';

export const getTracPageEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, GetTracPage>(GET_TRAC_PAGE),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active?.id),
    mergeMap(async ([_, state]) => {
      try {
        const trackPage = await tracPage.get(state.artist.active?.id as string);

        return new GetTracPageSuccess(trackPage);
      } catch (err) {
        return new GetTracPageError(err.message);
      }
    })
  );
